import { MenuItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import TextInput from 'components/TextInput/TextInput';
import { sortBy } from 'lodash-es';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { selectCurrentUserEmployerProjects } from 'store/resources/selectors/resources.selectors';
import { selectUserActiveEmployerId } from 'store/user/selectors.js/user.selectors';
import { handleChangeActiveEmployer } from 'store/user/thunks/handleChangeActiveEmployer.thunk';
import { selectCurrentUser } from 'store/userProfile/selectors/user-profile.selectors';

export const ActiveEmployerSelect = () => {
  const dispatch = useDispatch();

  const userEmployers = useSelector(selectCurrentUserEmployerProjects);

  const userCurrentActiveEmployerId = useSelector(selectUserActiveEmployerId);

  let history = useHistory();

  const changeActiveEmployer = (employerId) => {
    dispatch(
      handleChangeActiveEmployer({
        activeEmployerId: employerId,
        history,
        navigateToEmployer: true,
      })
    );
  };

  const { t } = useTranslation('common');

  const useStyles = makeStyles(() => ({
    root: {
      maxWidth: '300px',
      marginLeft: '2px',
      '& .MuiFilledInput-inputMarginDense': {
        paddingTop: '10px !important',
      },
      '& .MuiFilledInput-root': {
        '&:before': {
          display: 'none',
        },
        '&:after': {
          display: 'none',
        },
      },
      '& .MuiInputLabel-root': {
        color: '#fff !important',
      },
    },
    error: {
      '& .MuiFilledInput-root': {
        border: '1px solid #f44336',
      },
    },
  }));

  const classes = useStyles();

  const notFoundEmployer =
    userCurrentActiveEmployerId !== 'myLixani'
      ? !userEmployers.find(
          (employerProject) =>
            employerProject.id === userCurrentActiveEmployerId
        )
      : false;

  const user = useSelector(selectCurrentUser);

  const effectiveEmployerOptions =
    user.id === 'eu-west-1:4fd99331-0255-4d24-9214-43a5ae8e3b4a' ||
    process.env.REACT_APP_ENVIRONMENT_NAME !== 'prod'
      ? [...userEmployers, { id: 'myLixani', name: 'MyLixani' }]
      : userEmployers;

  if (userEmployers && userEmployers.length > 0) {
    return (
      <TextInput
        className={`${classes.root} ${
          !userCurrentActiveEmployerId || notFoundEmployer ? classes.error : ''
        }`}
        size="small"
        fullWidth
        id="business-select"
        label={t('toolbar.active_employer')}
        onChange={(e) => changeActiveEmployer(e.target.value)}
        select
        value={userCurrentActiveEmployerId || ''}
        displayEmpty
        variant="filled"
      >
        <MenuItem value="" disabled>
          <em>{t('toolbar.select_employer')}</em>
        </MenuItem>
        {sortBy(effectiveEmployerOptions, 'name').map((item) => (
          <MenuItem key={item.id} value={item.id}>
            {item.name}
          </MenuItem>
        ))}
      </TextInput>
    );
  } else {
    return null;
  }
};
